export default function Modal({ title, children, footer, size = "", centered = true, onClose, className = "" }) {
  const dialogClass = ["modal-dialog", centered ? "modal-dialog-centered" : "", size].filter(Boolean).join(" ");

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className={dialogClass} role="document">
        <div className={`modal-content ${className}`.trim()}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            {onClose && <button type="button" className="btn-close" onClick={onClose}></button>}
          </div>
          <div className="modal-body">{children}</div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
